<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Division</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="createDivision"
              >
                Create
              </CButton>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    placeholder="Search Division"
                    v-model="request.q"
                    @input="onSearch()"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="10"
            clickable-rows
            :active-page="1"
            :pagination="{ doubleArrows: false, align: 'center' }"
          >
            <template #division_action="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-0"
                    @click="editDivision(data.item.division_id)"
                  >
                    Edit
                  </CButton>
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="getDivisionList('REFRESH')"
            >
              Refresh
            </div>
            <div class="pagination-btn-back" @click="getDivisionList('BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ request.page }}</div>
            <div class="pagination-btn-next" @click="getDivisionList('NEXT')">
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import jwt from "jsonwebtoken";
import DivisionUseCase from '../app/usecase/division';

export default {
  name: "Division",
  data() {
    return {
      items: [],
      fields: [
        {key: 'division_id', label: 'ID'},
        {key: 'division_name', label: 'Divisi'},
        {key: 'status', label: 'Status'},
        {key: 'division_action', label: 'Action'},
      ],
      request: {
        page: 1,
        per_page: 10,
        q: ""
      },
      debounce: {
        timeout: 0,
        duration: 500,
      },
      searchTimout: null
    }
  },
  mounted() {
    this.authentication();
    this.getDivisionList()
  },
  beforeDestroy() {
    clearTimeout(this.searchTimout)
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "HRD" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    async getDivisionList(action) {
      try {
        this.validatePagination(action);
        const queryString = Object.keys(this.request).map((key) => key + "=" + this.request[key]).join("&");
        const { data, err } = await DivisionUseCase.getAll(queryString);
        if (err || data.data.length == 0) {
          this.validateNextPagination(action);
          this.err = err;
        } else {
          if (data) {
            window.scrollTo(0, 0);
            this.items = data.data;
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    async searchDivision() {
      try {
        await this.getDivisionList()
        this.request.page = 1
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err
        })
      }
    },
    onSearch() {
      clearTimeout(this.searchTimout)
      this.searchTimout = setTimeout(this.searchDivision, this.debounce.duration);
    },
    validatePagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page + 1;
      } else if (action === "BACK") {
        if (this.request.page > 1) {
          this.request.page = this.request.page - 1;
        }
      } else if (action === "REFRESH") {
        this.request.page = 1;
      } else {
        this.request.page = 1;
      }
    },
    validateNextPagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page - 1;
      } else {
        this.items = [];
      }
    },
    editDivision(id) {
      this.$router.push({ path: `/career/division/${id}` })
    },
    createDivision() {
      this.$router.push({ path: '/career/division/create' })
    }
  }
}

</script>
<style scoped>
@import "./Division.css";
</style>
